import { createAction, createReducer, on, props } from '@ngrx/store';

// Action Types
export const panelState = createAction('panelState');
export const panelIncrement = createAction('panelIncrement');
export const panelDecrement = createAction('panelDecrement');
export const panelReset = createAction('panelReset');
export const panelSet = createAction('panelSet', props<{ payload: number }>());

// Initial State
const initialState: number = 1;

// Reducer using NgRx `createReducer` and `on`
export const updatePanelReducer = createReducer(
  initialState,
  on(panelState, state => state),
  on(panelIncrement, state => state + 1),
  on(panelDecrement, state => state - 1),
  on(panelSet, (state, { payload }) => payload),
  on(panelReset, () => 1)
);
